// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'

// Utils
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Creates a selector that converts data to array of objects for react-select
// with { value, label }
export default function makeSelectOptionsSelector (label, label2, { id = 'id' } = {}) {
  return function (data$) {
    return createSelector(
      [data$],
      function (data) {
        return emptyArrayOr(_map(data, function (object) {
          return label2
            ? {
              value: object[id],
              label: object[label] + ' ' + object[label2],
            }
            : {
              value: object[id],
              label: object[label],
            }
        }))
      }
    )
  }
}
